@if (state.selectedCriteriaCurrency) {
  @switch (state.selectedCriteriaCurrency.code) {
    @case (inputCriteriaCurrencyCodeEnum.EQUAL_TO) {
      <div
        data-cy="input-criteria-currency-equal-to-wrapper">
        <ng-container *ngTemplateOutlet="currencyInputTemplate"></ng-container>
      </div>
    }
    @case (inputCriteriaCurrencyCodeEnum.BIGGER_THAN) {
      <div
        data-cy="input-criteria-currency-bigger-than-wrapper">
        <ng-container *ngTemplateOutlet="currencyInputTemplate"></ng-container>
      </div>
    }
    @case (inputCriteriaCurrencyCodeEnum.EQUAL_OR_BIGGER_THAN) {
      <div
        data-cy="input-criteria-currency-equal-or-bigger-than-wrapper">
        <ng-container *ngTemplateOutlet="currencyInputTemplate"></ng-container>
      </div>
    }
    @case (inputCriteriaCurrencyCodeEnum.SMALLER_THAN) {
      <div
        data-cy="input-criteria-currency-bigger-than-wrapper">
        <ng-container *ngTemplateOutlet="currencyInputTemplate"></ng-container>
      </div>
    }
    @case (inputCriteriaCurrencyCodeEnum.EQUAL_OR_SMALLER_THAN) {
      <div
        data-cy="input-criteria-currency-equal-or-bigger-than-wrapper">
        <ng-container *ngTemplateOutlet="currencyInputTemplate"></ng-container>
      </div>
    }
    @case (inputCriteriaCurrencyCodeEnum.BETWEEN) {
      <div
        class="input-criteria-currency-between-interval-wrapper"
        data-cy="input-criteria-currency-between-wrapper">
        <ng-container *ngTemplateOutlet="currencyInputTemplate"></ng-container>
        <span class="input-criteria-currency-text"
        data-cy="input-criteria-currency-between-intervals">to</span>
        <ng-container *ngTemplateOutlet="extraCurrencyInputTemplate"></ng-container>
      </div>
    }
  }
} @else {
  <app-select-dropdown
    [dropdownDefaultButtonText]="inputCriteriaCurrencyConfiguration.dropdownDefaultButtonText"
    [dropdownData]="inputCriteriaCurrencyConfiguration.dropdownData"
    (selectedOption)="selectedOptionHandler($event)"
  data-cy="input-criteria-currency-select-option"></app-select-dropdown>
}


<ng-template #currencyInputTemplate>
  <app-input-units #currencyInput
    (inputStateChange)="manageDefaultInputStatusChange($event)"
    (inputValueChange)="setDefaultValue($event)"
    (keydown.enter)="submitCurrencyCriteria()"
    [baseCypressTag]="'input-criteria-currency-default'"
    [decimalDirective]="true"
    [units]="inputCriteriaCurrencyConfiguration.unit"
    [maxLength]="inputCriteriaCurrencyConfiguration.maxLength"
    [placeholder]="inputCriteriaCurrencyConfiguration.placeholder"
    [alternateBackground]="true"
    [width]="'170px'"
    [validators]="validators.currencyFormat"
    [messages]="currencyInputMessages">
  </app-input-units>
</ng-template>

<ng-template #extraCurrencyInputTemplate>
  <app-input-units #extraCurrencyInput
    (inputStateChange)="manageDefaultInputStatusChange($event, true)"
    (inputValueChange)="setExtraValue($event)"
    (keydown.enter)="submitCurrencyCriteria()"
    [baseCypressTag]="'input-criteria-currency-extra'"
    [decimalDirective]="true"
    [units]="inputCriteriaCurrencyConfiguration.unit"
    [maxLength]="inputCriteriaCurrencyConfiguration.maxLength"
    [placeholder]="inputCriteriaCurrencyConfiguration.placeholder"
    [alternateBackground]="true"
    [width]="'170px'"
    [validators]="validators.currencyFormat"
    [messages]="extraCurrencyInputMessages">
  </app-input-units>
</ng-template>
